import { type LogLevel } from './logger.types';

export interface LoggerConfig {
  enableProductionLogging: boolean;
  minLogLevel: LogLevel;
  globalPrefix: string;
}

export const LOG_LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 0,
  log: 1,
  info: 2,
  warn: 3,
  error: 4,
};
